/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, debug) {
	'use strict';

	/**
	 * Initialize all SDX Information Call Out.
	 *
	 * Used for Desktop and Mobile
	 *
	 * @author Rami Attallah
	 */
	Module.CallOutSdx = Module.extend({


		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.isMobileOnly = $ctx.hasClass('isMobileOnly');
			mod.isMobile = SCS.utils.isMobilePage();

			// Configuration
			mod.content = $ctx.text();
			if (mod.isMobileOnly && !mod.isMobile) {
				// render as text on desktop
				$ctx.removeClass('mod modCallOut isMobileOnly').attr('style', '');
				return;
			}

			$ctx.hide();

			callback();
		},

		after: function () {
			var mod = this,
				$callout = $('<button/>'),
				$icon = $('<i/>');

			$icon.addClass('icon icon-046-information-circle');
			$callout.attr('aria-label', mod.content)
				.addClass('toolbar__item item--show tooltip')
				.append($icon);
			if(mod.$ctx.hasClass('right')) {
				$callout.addClass('tooltip--right');
			}
			mod.$ctx.replaceWith($callout);
		}
	});
}(window.Tc.Module, window.Tc.$, window.debug));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.CallOutSdx.js
// module id = 133
// module chunks = 0